import { headerHeight } from 'styles/colors';
import styled from 'styled-components';

// Stays at the top while scrolling so the section links are always within reach
export const Wrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 5;
  width: 100%;
  height: ${headerHeight};
  background: #fff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  display: none;
  transition: 0.4s;

  ${({ sidebar }) =>
    sidebar &&
    `
			display: block;
			z-index: 4;	
	`}
`;
